import { Skeleton } from "@/components/ui/skeleton";
import Loading from "../common/loading";
import { backofficeLinks } from "@/components/lib/SidebarLinks";

export default function TableSkeleton({ links = backofficeLinks }) {
  return (
    <Loading links={links}>
      <div className="p-4 space-y-6 max-w-7xl mx-auto w-full mt-5">
        {/* Header Section */}
        <div className="flex justify-between items-center">
          <Skeleton className="h-10 w-48" /> {/* Title */}
          <div className="flex gap-2">
            <Skeleton className="h-10 w-24 rounded-md" />
            <Skeleton className="h-10 w-24 rounded-md" />
          </div>
        </div>

        {/* Search & Filter */}
        <div className="flex justify-between items-center">
          <Skeleton className="h-9 w-72 rounded-md" />
          <div className="flex gap-2">
            <Skeleton className="h-9 w-24 rounded-md" />
            <Skeleton className="h-9 w-24 rounded-md" />
          </div>
        </div>

        {/* Table Header */}
        <div className="grid grid-cols-6 gap-4 px-2">
          <Skeleton className="h-6 w-full col-span-1" />
          <Skeleton className="h-6 w-full col-span-1" />
          <Skeleton className="h-6 w-full col-span-1" />
          <Skeleton className="h-6 w-full col-span-1" />
          <Skeleton className="h-6 w-full col-span-1" />
          <Skeleton className="h-6 w-full col-span-1" />
        </div>

        {/* Table Rows (5 placeholder rows) */}
        {[...Array(7)].map((_, i) => (
          <div key={i} className="grid grid-cols-6 gap-4 px-2">
            <Skeleton className="h-8 w-full col-span-1 rounded-md" />
            <Skeleton className="h-8 w-full col-span-1 rounded-md" />
            <Skeleton className="h-8 w-full col-span-1 rounded-md" />
            <Skeleton className="h-8 w-full col-span-1 rounded-md" />
            <Skeleton className="h-8 w-full col-span-1 rounded-md" />
            <Skeleton className="h-8 w-full col-span-1 rounded-md" />
          </div>
        ))}

        {/* Pagination */}
        <div className="flex justify-end gap-2">
          <Skeleton className="h-8 w-20 rounded-md" />
          <Skeleton className="h-8 w-20 rounded-md" />
        </div>
      </div>
    </Loading>
  );
}
